import 'jquery-ui/dist/jquery-ui.min.js';
import '@fancyapps/fancybox/dist/jquery.fancybox.min.js';
import 'slick-carousel';
import Choices from 'choices.js';
import 'jquery.cookie';
import 'flatpickr/dist/flatpickr.min.js';
import Headroom from 'headroom.js/dist/headroom.min.js';

/* ==========================================================================
   Fade in elements with intersection observer
   ========================================================================== */

if ('IntersectionObserver' in window) {
	var observer = new IntersectionObserver(function (entries) {
		entries.forEach(function (entry) {
			if (entry.isIntersecting === true) {
				entry.target.classList.add("fade-in--is-visible");
			} else {
				//entry.target.classList.remove("fade-in--is-visible");
			}
		});
	});
	var items = document.querySelectorAll(".fade-in");
	items.forEach(function (item, index) {
		observer.observe(item, index);
	});
} else {
	document.querySelector("body").classList.add("no-intersection-observer")
}

/* ==========================================================================
   Mobile Menu Button
   ========================================================================== */

$(".js-toggle-mobile-nav").click(function (e) {
	e.preventDefault();
	$(this).toggleClass("is-active");
	$(".main-nav").fadeToggle(250);

	//Move the search bar into the mobile menu
	if ($(".header .main-search-form").length) {
		$(".main-nav").append($(".main-search-form").show());
	}
});

/* ==========================================================================
   Change header on scroll
   ========================================================================== */

if (document.querySelector(".header")) {
	let heroHeight;
	if ($('.home-hero').length) {
		heroHeight = $(".home-hero").outerHeight() - $(".header").outerHeight();
	} else {
		heroHeight = 10;
	}
	var headroomOptions = {
		offset: {
			up: 0,
			down: heroHeight
		}
	}
	const headroomHeader = document.querySelector(".header");
	const headroom = new Headroom(headroomHeader, headroomOptions);
	headroom.init();
}

/* ==========================================================================
   Advanced Search Button
   ========================================================================== */

if (document.querySelector(".js-toggle-advanced-search")) {
	const advancedSearchForm = document.querySelector(".search-form__main-secondary");
	document.querySelector(".js-toggle-advanced-search").addEventListener("click", function (event) {
		event.preventDefault();
		this.classList.toggle("is-active");
		if (this.getAttribute("aria-expanded") == "true") {
			this.setAttribute("aria-expanded", "false");
			advancedSearchForm.setAttribute("aria-hidden", "true");
		} else {
			this.setAttribute("aria-expanded", "true");
			advancedSearchForm.setAttribute("aria-hidden", "false");
		}
		advancedSearchForm.classList.toggle("is-active");
	});
}

/* ==========================================================================
   Choices.js Multi select
   ========================================================================== */

// Options - https://github.com/jshjohnson/Choices
if (document.querySelector(".js-choices")) {
	var element = document.querySelector('.js-choices');
	window.choices = new Choices(element, {
		removeItemButton: true
	});
}

/* ==========================================================================
   Slick Sliders
   ========================================================================== */

if ($('.js-hero-slider').length) {
	$('.js-hero-slider').each(function () {
		$(this).slick({
			infinite: false,
			dots: false,
			arrows: true,
			slidesToShow: 2,
			slidesToScroll: 1,
			prevArrow: '<button class="slick-prev slick-arrow"><span class="screen-reader-text">Previous slide</span> <svg class="icon" role="presentation"><use xlink:href="#icon-chevron-left"></use></svg></button>',
			nextArrow: '<button class="slick-next slick-arrow"><span class="screen-reader-text">Next slide</span> <svg class="icon" role="presentation"><use xlink:href="#icon-chevron-right"></use></svg></button>',
			appendArrows: $(this).parents(".hero-slider").find(".arrows-append"),
			responsive: [
				{
					breakpoint: 1281,
					settings: {
						slidesToShow: 1,
					}
				},
				{
					breakpoint: 760,
					settings: {
						slidesToShow: 1,
						arrows: false,
					}
				}
			]
		});
	});
}

if ($('.image-slider').length) {
	$('.image-slider').slick({
		adaptiveHeight: true,
		fade: true,
		arrows: true,
		dots: false,
		prevArrow: '<button class="slick-prev slick-arrow"><span class="screen-reader-text">Prev</span> <svg class="icon" role="presentation"><use xlink:href="#icon-chevron-left"></use></svg></button>',
		nextArrow: '<button class="slick-next slick-arrow"><span class="screen-reader-text">Next</span> <svg class="icon" role="presentation"><use xlink:href="#icon-chevron-right"></use></svg></button>'
	});
}
